@if (application(); as application) {
  <div class="application-details">
    <div class='row'>
      <div class='col-md-3'>
        <app-label label='Data utworzenia:'>
          {{ application?.createdAt | date }}
        </app-label>
      </div>
      <div class='col-md-3'>
        <app-label label='Data zatwierdzenia:'>
          {{ application?.updatedAt | date }}
        </app-label>
      </div>
      <div class='col-md-6'>
        <app-label label='Numer sprawy:'>
          {{ application?.caseNumber || '-' }}
        </app-label>
      </div>
    </div>
    <ng-container *ngIf='shipments()?.length'>
      <br>
      <app-decision-data-preview [canPay]="canPay()" [shipments]="shipments()">
      </app-decision-data-preview>
      <br>
    </ng-container>
    <app-applicant-preview
      [application]="application"
      [expanded]="expanded">
    </app-applicant-preview>
    <br>
    <h3>
      Dane wniosku
    </h3>
    <app-application-data-preview [application]="application">
    </app-application-data-preview>
    <br>
    <h3>
      Informacje o wycince
    </h3>
    <p class="mb-2">
      Dane posiadacza / właściciela nieruchomości której dotyczy wycinka
    </p>
    <div class="row">
      <div class='col-md-4'>
        <app-label label='Imię i nazwisko / nazwa:'>
          {{ application?.propertyOwnerFullName || '-' }}
        </app-label>
      </div>
      <div class='col-md-4'>
        <app-label label='Kod pocztowy:'>
          {{ application?.propertyOwnerPostalCode || '-' }}
        </app-label>
      </div>
      <div class='col-md-4'>
        <app-label label='Poczta:'>
          {{ application?.propertyOwnerPostOffice || '-' }}
        </app-label>
      </div>
      <div class='col-md-4'>
        <app-label label='Miejscowość:'>
          {{ application?.propertyOwnerCity || '-' }}
        </app-label>
      </div>
      <div class='col-md-4'>
        <app-label label='Ulica:'>
          {{ application?.propertyOwnerStreet || '-' }}
        </app-label>
      </div>
      <div class="col-md-4">
        <app-label label='Nr domu:'>
          {{ application?.propertyOwnerHouseNumber || '-' }}
        </app-label>
        &nbsp;
        <app-label label='Nr mieszkania:'>
          {{ application?.propertyOwnerApartmentNumber || '-' }}
        </app-label>
      </div>
    </div>
    <br>
    <p class="md-2">
      Termin wycinki
    </p>
    <div class="row">
      <div class="col-md-4">
        <app-label label="Termin zamierzonego usunięcia drzewa/krzewu (Data do):">
          {{ application?.intendedRemovalDate | date }}
        </app-label>
      </div>
    </div>
    <br>
    <p class="mb-2">
      Lista drzew i krzewów do wycinki
    </p>
    <app-trees-to-remove-preview
      [expanded]="true"
      [treesToRemove]="treesToRemove()"
      [showActions]="false">
    </app-trees-to-remove-preview>
    <br>
    <h3>
      Oświadczenia
    </h3>
    <div class="row">
      <div class="col-12">
        <app-label
          label="Pouczony o odpowiedzialności za składanie fałszywych zeznań na podstawie art. 75 § 2 ustawy z dnia 14 czerwca 1960 r. Kodeks postępowania administracyjnego oświadczam, że dane zawarte w tym wniosku są zgodne ze stanem faktycznym:">
          {{ application?.testimonyStatement ? 'Tak' : 'Nie' }}
        </app-label>
      </div>
      <div class="col-12">
        <app-label [label]="'Oświadczam, że ' + (application?.propertyUsagePurpose | propertyOwnerStatementContent)  + ':'">
          {{ application?.propertyOwnerStatement ? 'Tak' : 'Nie' }}
        </app-label>
      </div>
      <div class="col-12">
        <app-label
          label="Usunięcie drzewa (drzew) lub krzewów wynika z celu związanego z prowadzeniem działalności gospodarczej:">
          {{ application?.removalForBusinessPurpose ? 'Tak' : 'Nie' }}
        </app-label>
      </div>
    </div>
    <br>
    <h3>
      Zgody
    </h3>
    <app-agreements-data-preview [application]="application">
    </app-agreements-data-preview>
    <br>
    <h3>
      Załączniki
    </h3>
    <app-attachments-data-preview [application]="application">
    </app-attachments-data-preview>
  </div>
}
